// ThemeToggleButton.tsx
import React from "react";
import { useTheme } from "../../context/ThemeContext";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import { Button } from "@mui/material";

const ThemeToggleButton: React.FC = () => {
  const { mode, toggleTheme } = useTheme();

  return (
    <Button onClick={toggleTheme} disableRipple fullWidth>
      {mode === "light" ? (
        <>
          <DarkModeIcon /> Dark theme
        </>
      ) : (
        <>
          <LightModeIcon /> Light theme
        </>
      )}
    </Button>
  );
};

export default ThemeToggleButton;
